export const stripeProductFragment = `
fragment FStripeProduct on StripeProductDto {
  uniqName
  displayId
  id
  metadata
  isShowOnShop
  evaluationId
  shopProductGroupIds
  prices {
    id
    displayId
    nickname
  }
}
`;

export const cartFragment = `
fragment FCart on CartDto {
  sysId
  status
  cartItems {
    teleConsultForSkipEval
    completedEval
    price {
      active
      id
      unit_amount_decimal
    }
    consultationSessionType
    product {
      metadata
      evaluationId
      active
      uniqName
      id
      image {
        noahVertical
        noahWide
      }
    }
  }
}`;
